import { render, staticRenderFns } from "./examGuidanceVideo.vue?vue&type=template&id=c51abbfe&scoped=true&"
import script from "./examGuidanceVideo.vue?vue&type=script&lang=js&"
export * from "./examGuidanceVideo.vue?vue&type=script&lang=js&"
import style0 from "./examGuidanceVideo.vue?vue&type=style&index=0&id=c51abbfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51abbfe",
  null
  
)

export default component.exports